import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {categories, ItemCategory} from '../../model/item-category';

@Component({
    selector: 'app-category-selector',
    templateUrl: './category-selector.component.html',
    styleUrls: ['./category-selector.component.scss'],
    standalone: false
})
export class CategorySelectorComponent implements OnInit {

  @Input()
  selected: string;

  @Output()
  select: EventEmitter<ItemCategory> = new EventEmitter<ItemCategory>();

  readonly categories = categories;

  constructor() {
  }

  ngOnInit(): void {
  }

  onSelect(category: ItemCategory): void {
    this.select.emit(category);
  }
}
